import React from 'react';
import Cleave from 'cleave.js/react';
import styled, { css } from 'styled-components';
import { theme } from '../styles/theme';
import { fadeIn } from '../styles/animations';

const CalculatorInput = ({
  id,
  label,
  value,
  onChange,
  error,
  options,
  placeholder,
}) => {
  const errorId = `error-${id}`;

  return (
    <Wrapper>
      <Label htmlFor={id}>{label}</Label>
      <Cleave
        id={id}
        data-testid={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
        className={error ? 'invalid' : ''}
        options={options}
      />
      {error && (
        <ErrorMessage id={errorId} data-testid={errorId} role="alert">
          {error}
        </ErrorMessage>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`;

const Label = styled.label`
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${theme.colors.textSecondary};
`;

const ErrorMessage = styled.span`
  display: block;
  font-size: 11px;
  color: ${theme.colors.dangerLight};
  letter-spacing: 0.2px;

  ${css`
    animation: ${fadeIn} 0.15s ease both;
  `}
`;

export default CalculatorInput;
